import { Head } from 'features/head'
import { Suspense, lazy } from 'react'

const BonusTemplates = lazy(() => import('features/bonus-templates/index'))

export const BonusTemplatesPage: React.FC = () => {
  return (
    <>
      <Head title='Bonus Templates' />
      <Suspense fallback={<p>Loading...</p>}>
        <BonusTemplates />
      </Suspense>
    </>
  )
}
